<template>
  <Box>
    <BoxHead
      icon="fas fa-user"
    >
      Personal Information
    </BoxHead>

    <div
      class="personal-information-body"
    >
      <DetailsList>
        <DetailPair
          label="Joined"
          :value="formatShortDate(entity.created_at)"
        />

        <DetailPair
          label="Name"
          :value="entity.name"
        />

        <DetailPair
          label="Email"
          :value="entity.email"
        />

        <DetailPair
          label="Type"
        >
          <Badge
            v-if="entity.entity_type === 'Prospect'"
            status="info"
          >
            Prospect
          </Badge>
          <Badge
            v-else-if="entity.entity_type === 'Client'"
            status="success"
          >
            Client
          </Badge>
          <Badge v-else>
            Other
          </Badge>
        </DetailPair>

        <DetailPair
          label="Part of"
        >
          <template v-if="entity.parents?.length">
            <router-link
              v-for="parent in entity.parents"
              :key="parent.external_id"
              :to="entityDetailLink(parent.external_id)"
              class="parent-link"
            >
              {{ parent.name }}
            </router-link>
          </template>
          <span v-else>None</span>
        </DetailPair>

        <DetailPair
          label="Includes"
        >
          <template v-if="entity.children?.length">
            <router-link
              v-for="parent in entity.children"
              :key="parent.external_id"
              :to="entityDetailLink(parent.external_id)"
              class="parent-link"
            >
              {{ parent.name }}
            </router-link>
          </template>
          <span v-else>None</span>
        </DetailPair>

        <DetailPair
          label="Client Portal"
          :value="prettifyMixedCase(entity.portal_status)"
        />

        <DetailPair
          label="CRM linked?"
          :value="entity.crm_connection_id ? 'Yes' : 'No'"
        />

        <DetailPair
          label="Holdings synced?"
          :value="entity.holdings_synced ? 'Yes' : 'No'"
        />
      </DetailsList>
    </div>
  </Box>
</template>

<script setup>
import { Badge, Box, BoxHead, DetailsList, DetailPair, LoaderWithText } from '@stakeui';
import { formatShortDate, prettifyMixedCase } from '@frontend/shared/Util.js';

defineProps({
  entity: {
    type: Object,
    required: true,
  },
});

const entityDetailLink = externalId => ({
  name: 'entity-detail',
  params: { entityExternalId: externalId },
});
</script>

<style scoped>
</style>
